module.exports = __webpack_public_path__ + "media/images/logos/windeurope-offshore2019-156cc3cedf12ad85f4255448f071d3c7.svg";